import request from "../utils/request";
import store from "@/store/store";


export async function setBranchProductPrice(branchProductPrice) {
  return request.post("BranchProductPrice/SetBranchProductPrice", branchProductPrice);
}
export async function setBranchProductPriceList(branchProductPriceList) {
  return request.post("BranchProductPrice/SetBranchProductPriceList", branchProductPriceList);
}
export async function updatedAllDataByList(data) {
  return request.post("BranchProductPrice/UpdatedAllDataByList", data);
}

export async function getBranchProductPrice(productId,branchId) {
    return request.get('BranchProductPrice/GetBranchProductPrice',{
      params: {
        listId: branchId,
        productId:productId
      }
    });
  }

  export async function getBranchProductPriceLists() {
    return new Promise((resolve, reject) => {
      
        try {
          request.get('BranchProductPrice/GetBranchProductPriceLists').then(res => {
            resolve(res.data);
          });
        } catch (error) {
          reject(error)
        }
    });

   
  }
  export async function getAllBranchProductPriceByBranchId(listId){
    return request.get('BranchProductPrice/GetAllBranchProductPriceByBranchId',{
      params: {
        listId: listId
      }
    });
  }

  export async function getAllAdditiveProducts(listId){
    return request.get('BranchProductPrice/GetAllAdditiveProducts',{
      params: {
        listId: listId
      }
    });
  }

  export async function deletePriceById(listId,item){
    return request.get('BranchProductPrice/DeletePriceById',{
      params: {
        productId: item.productId,
        listId:listId,
        isExtra: item.isExtra
      }
    });
    
  }

  export async function createProductPriceList(name){
    return request.post('BranchProductPrice/CreateProductPriceList',name);
    
  }

  export async function updateProductPriceList(name){
    return request.post('BranchProductPrice/UpdateProductPriceList',name);
    
  }

  export async function deleteList(listId){
    return request.delete('BranchProductPrice',{
      params: {
        listId:listId
      }
    });
    
  }

  export async function GetPriceListExcel(listId) {
    return request.get("BranchProductPrice/GetPriceListExcel?listId="+listId, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.ms-excel'
      }
    })
  }